<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitCreateUnit">

      <div class="form-group">
        <p>Тип: {{ currentType }}</p>
      </div>

      <div class="form-group">
        <p>Модель: {{ currentModel.code }}</p>
      </div>

      <div class="form-group">
        <label for="with_nds">Название:</label>
        <input
            id="with_nds"
            v-model="unitData.name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.unitData.name.$error }"
        />
        <div v-if="submitted && $v.unitData.name.$error" class="invalid-feedback">
          <span v-if="!$v.unitData.name.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.unitData.name.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.unitData.name.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="with_nds">Серийный номер:</label>
        <input
            id="with_nds"
            v-model="unitData.serial_number"
            type="text"
            class="form-control form-control-sm"
        />
      </div>

      <div class="form-group">
        <label for="with_nds">Цена для держателя:</label>
        <input
            type="text"
            v-model="unitData.last_price_for_holder"
            @input="handleInput"
            placeholder="0.00"
            class="form-control form-control-sm"
        />
      </div>

<!--      <div class="form-group">-->
<!--        <label for="with_nds">Дата оприходования:</label>-->
<!--        <input-->
<!--            id="with_nds"-->
<!--            v-model="unitData.incoming_date"-->
<!--            type="date"-->
<!--            class="form-control form-control-sm"-->
<!--        />-->
<!--      </div>-->

      <div class="form-group">
        <label for="with_nds">Примечания:</label>
        <input
            id="with_nds"
            v-model="unitData.description"
            type="text"
            class="form-control form-control-sm"
        />
      </div>

    </form>
  </div>

</template>

<script>

import {integer, email, maxLength, maxValue, minLength, minValue, required} from "vuelidate/lib/validators";

import axios from "axios";

export default {
  // mixins: [validationMixin],
  name: "CreateUnit",
  data() {
    return {
      currentType: null,
      currentModel: {
        id: null,
        code: null,
      },
      unitData: {
        model_id: null,
        serial_number: null,
        incoming_date: null,
        name: null,
        last_price_for_holder: 0,
        description: null
      },
      submitted: false,
    }
  },
  validations: {
    unitData: {
      name: {required, minLength: minLength(1), maxLength: maxLength(255)},
    },
  },
  methods: {
    handleInput(event) {
      let value = event.target.value;

      // 1. Разрешаем только цифры, точки и запятые
      let cleanValue = value.replace(/[^\d.,]/g, '');

      // 2. Заменяем запятую на точку для стандартизации
      cleanValue = cleanValue.replace(',', '.');

      // 3. Удаляем дублирующиеся точки (оставляем только первую)
      const firstDotIndex = cleanValue.indexOf('.');
      if (firstDotIndex !== -1) {
        cleanValue = cleanValue.slice(0, firstDotIndex + 1) +
            cleanValue.slice(firstDotIndex + 1).replace(/\./g, '');
      }

      // 4. Отрезаем всё, что идет после двух знаков после точки
      if (cleanValue.includes('.')) {
        const parts = cleanValue.split('.');
        if (parts[1] && parts[1].length > 2) {
          cleanValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
        }
      }

      // 5. Обновляем модель (реактивно для Vue)
      this.unitData.last_price_for_holder = cleanValue;

      // 6. Передаем наверх чистое число (или null, если поле пустое)
      const numericValue = cleanValue ? parseFloat(cleanValue) : null;
      this.$emit('input', numericValue);
    },
    initData(currentTypeName, currentModel) {
      this.currentType = currentTypeName;
      this.currentModel = currentModel;
    },
    submitCreateUnit() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.unitData.$touch();
      if (!this.$v.unitData.$invalid) {
        this.createNewUnit();
      }
    },
    createNewUnit() {
      let formData = new FormData();
      formData.append('model_id', this.currentModel.id);
      formData.append('serial_number', this.unitData.serial_number);
      formData.append('name', this.unitData.name);
      formData.append('last_price_for_holder', this.unitData.last_price_for_holder);
      // formData.append('incoming_date', this.unitData.incoming_date);
      formData.append('description', this.unitData.description);

      axios
          .post(`/v1/units/incoming`, formData)
          .then(resp => {
            this.$emit('new-unit-created', resp.data);
            this.$store.dispatch("addNotification", {
              text: this.$t('popularWords.successfully'),
              time: 3,
              color: "success"
            });
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    }
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
